import _jsx from "@babel/runtime/helpers/jsx";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

var _HomePageHeader, _PageFooter, _PageSidebar;

var _excluded = ["type"];
import React, { memo, useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Page from 'components/Page';
import HomePageHeader from 'components/HomePageHeader';
import PageInner from 'components/PageInner';
import PageContent from 'components/PageContent';
import PageSidebar from 'components/PageSidebar';
import LayoutContainer from 'components/LayoutContainer';
import PageFooter from 'components/PageFooter';
import ProductsList from 'components/ProductsList';
import { useSelectorProps } from 'hooks';
import { fetchProductsByFilters } from 'actions';
import { getCompaniesWithProducts, getProductsIsLoaded, getProductsIsFetching, getProductsIsRequestFailed, getOrganizationsIsRequestFailed, getFormattedSearchParams } from 'selectors';
import Content from './styles';
var HomePage = /*#__PURE__*/memo(function (_ref) {
  var loadData = _ref.loadData,
      staticContext = _ref.staticContext;
  var selectorProps = useSelectorProps();
  var dispatch = useDispatch();
  var didMount = useRef(null);

  var _useSelector = useSelector(function (state) {
    return getFormattedSearchParams(state, selectorProps);
  }),
      type = _useSelector.type,
      otherParams = _objectWithoutProperties(_useSelector, _excluded);

  var isLoaded = useSelector(function (state) {
    return getProductsIsLoaded(state, selectorProps);
  });
  var isFetching = useSelector(function (state) {
    return getProductsIsFetching(state, selectorProps);
  });
  var organizationsIsRequestFailed = useSelector(function (state) {
    return getOrganizationsIsRequestFailed(state, selectorProps);
  });
  var productsIsRequesFailed = useSelector(function (state) {
    return getProductsIsRequestFailed(state, selectorProps);
  });
  var visible = useSelector(function (state) {
    return getCompaniesWithProducts(state, selectorProps);
  });
  var productsCount = useMemo(function () {
    return visible.reduce(function (res, curr) {
      var _curr$products;

      return res + (curr == null ? void 0 : (_curr$products = curr.products) == null ? void 0 : _curr$products.length);
    }, 0);
  }, [visible]);
  useEffect(function () {
    loadData(dispatch, selectorProps);
  }, [selectorProps]);

  if ((organizationsIsRequestFailed || productsIsRequesFailed) && staticContext) {
    staticContext.status = 404;
  }

  useEffect(function () {
    if (didMount.current) {
      dispatch(fetchProductsByFilters(selectorProps));
    }

    didMount.current = true;
  }, [didMount.current, JSON.stringify(otherParams)]);
  return /*#__PURE__*/_jsx(Page, {}, void 0, _HomePageHeader || (_HomePageHeader = /*#__PURE__*/_jsx(HomePageHeader, {})), /*#__PURE__*/_jsx(Content, {}, void 0, /*#__PURE__*/_jsx(LayoutContainer, {}, void 0, /*#__PURE__*/_jsx(PageInner, {}, void 0, /*#__PURE__*/_jsx(PageContent, {}, void 0, /*#__PURE__*/_jsx(ProductsList, {
    visibleProducts: visible,
    productsCount: productsCount,
    isLoaded: isLoaded,
    isFetching: isFetching,
    isRequestFailed: organizationsIsRequestFailed || productsIsRequesFailed
  }), _PageFooter || (_PageFooter = /*#__PURE__*/_jsx(PageFooter, {
    isShowTextBlocks: true
  }))), _PageSidebar || (_PageSidebar = /*#__PURE__*/_jsx(PageSidebar, {}))))));
});
HomePage.defaultProps = {
  staticContext: null
};
export default withRouter(HomePage);